import { Component, EventEmitter, Input, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { NavigationItem } from '../navigation_item';

@Component({
  selector: 'yi-tab-bar',
  template: require('./tab_bar.component.html'),
  styles: [require('./tab_bar.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabBarComponent implements OnChanges {
  @Input() tabBarItems: Array<NavigationItem>;

  @Output() itemClicked = new EventEmitter();

  activeItem: NavigationItem;

  private static findActiveItem(items: Array<NavigationItem>) {
    return items.filter(state => state.active === true)[0];
  }

  ngOnChanges(changes) {
    if (changes.tabBarItems) {
      this.activeItem = TabBarComponent.findActiveItem(changes.tabBarItems.currentValue);
    }
  }

  itemClickedOn(newActiveStep: NavigationItem) {
    if (this.isStepDone(newActiveStep)) {
      this.itemClicked.emit({item: newActiveStep});
    }
  }

  isStepDone(item: NavigationItem) {
    return item.finished === true;
  }

  isAdvanceStep(activeItem: NavigationItem, currentItem: NavigationItem) {
    let prevStep = currentItem.prevStep;
    if (!prevStep) {
      return false;
    } else if (prevStep === activeItem) {
      return true;
    }
    return this.isAdvanceStep(activeItem, prevStep);
  }
}
